import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';

const CommandList = forwardRef((props, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const toggleItem = (index) => {
    const item = props.items[index];

    if (item) {
      props.command(item);
    }
  };

  const upHandler = () => {
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    toggleItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [props.items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        downHandler();
        return true;
      }

      if (event.key === 'Enter') {
        enterHandler();
        return true;
      }

      return false;
    },
  }));

  return (
    <div className="slash-menu">
      <div className="px-3 py-2 border-b border-slate-100 mb-1">
        <span className="text-[10px] font-black text-slate-400 uppercase tracking-[0.15em]">
          Commands
        </span>
      </div>
      {props.items.length ? (
        props.items.map((item, index) => (
          <button
            className={`slash-item ${index === selectedIndex ? 'is-selected' : ''}`}
            key={index}
            onClick={() => toggleItem(index)}
          >
            <div className="icon-box">
              {item.icon}
            </div>
            <div>
              <p className="text-sm font-bold text-[#18216D] leading-tight">
                {item.title}
              </p>
              <p className="text-[10px] text-slate-400 font-medium">
                {item.description}
              </p>
            </div>
          </button>
        ))
      ) : (
        <div className="p-4 text-center">
          <p className="text-xs text-slate-400 font-bold italic">No results found</p>
        </div>
      )}
    </div>
  );
});

export default CommandList;
